import { employeeStore, userStore } from '../../stores';
import { EmployeeController } from '../../controllers';
import { amountFormatter } from '../../utils/utils';
import { MimaToastUtil } from '../../components';
import { useNavigate } from 'react-router-dom';
import { object, number, string } from 'yup';
import constant from '../../utils/constant';
import { ViewGroups } from '../../pages';
import React, { useState } from 'react';
import { observer } from 'mobx-react';

const ViewGroupsContainer = ({ closeModal }) => {
	const [createGroup, setCreateGroup] = useState(false);
	const [groupDetails, setGroupDetails] = useState(false);
	const [loading, setLoading] = useState(false);

	const goBack = () => {
		employeeStore.setSelectedEmployeeGroup({});
		closeAllModal();
	};

	const navigate = useNavigate();

	const isOnboardingDone = () => {
		if (userStore.isOnBoardingDone === 'false') {
			MimaToastUtil.error({
				message: constant.OnboardingRequired,
			});
			localStorage.setItem(constant.RoutePath, constant.Routes.Employees);
			return navigate(constant.Routes.OnboardingStageOne);
		}
	};
	const showCreateGroup = () => {
		// isOnboardingDone();
		setCreateGroup(true);
	};
	const closeAllModal = () => {
		employeeStore.setSelectedEmployeeGroup({});
		setCreateGroup(false);
		setGroupDetails(false);
		closeModal();
	};
	const showGroupDetails = () => {
		setGroupDetails(true);
	};

	const validationSchema = () =>
		object({
			employmentType: string().required('Employment Type is required'),
			settlementCycle: string().required('Settlement Cycle is required'),
			name: string().required('Title is required'),
		});

	const onSubmit = async payload => {
		setLoading(true);

		delete payload.departmentName;
		
		for (const key in payload) {
			if (payload[key] === '') {
				delete payload[key];
			}
		}
		const group = employeeStore.selectedEmployeeGroup;
		let controller;
		if (Object.keys(group).length === 0) {
			controller = EmployeeController.createGroup(payload);
		} else {
			controller = EmployeeController.updateGroup(payload, group._id);
		}
		const { status, errorMessage } = await controller;
		employeeStore.setSelectedEmployeeGroup({});
		if (status === constant.Success) {
			setLoading(false);
			MimaToastUtil.success({
				message: constant.Success,
			});
			return closeModal();
		}
		setLoading(false);
		return MimaToastUtil.error({
			message: errorMessage,
		});
	};

	const addFundList = [
		'Bonus',
		'Overtime',
		'Time Off',
		'Retainer',
		'Welfare',
		'Severance',
		'Reimbursement',
		'SalaryAdvance',
		'Commission',
		'Others',
	];

	const addDeductionList = [
		'Penalty',
		'Time Off',
		'Reimbursement',
		'Welfare',
		'Loan Repayment',
		'Others',
	];

	const totalExtra = extra => {
		const totalAmount =
			extra?.reduce(
				(previousValue, currentValue) => previousValue + currentValue.amount,
				0
			) || 0;
		return amountFormatter().format(totalAmount);
	};

	const groupNames = employeeStore.groups;

	return (
		<ViewGroups
			addFundList={addFundList}
			addDeductionList={addDeductionList}
			totalExtra={totalExtra}
			closeModal={closeAllModal}
			loading={loading}
			employees={employeeStore.mappedEmployees}
			createGroup={createGroup}
			showCreateGroup={showCreateGroup}
			groupDetails={groupDetails}
			onSubmit={onSubmit}
			validationSchema={validationSchema}
			showGroupDetails={showGroupDetails}
			groupNames={groupNames}
			goBack={goBack}
		/>
	);
};

export default observer(ViewGroupsContainer);
